import script from "./PaymentView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentView.vue?vue&type=script&setup=true&lang=js"

import "./PaymentView.vue?vue&type=style&index=0&id=d481a28c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d481a28c"]])

export default __exports__